import React, { useMemo } from 'react';
import CsvIconComponent from '../../../../../src/assets/images/studio/data-source/csv.svg';
import CSVLight from '../../../../../src/assets/images/studio/data-source/csv-light.svg';

interface CSVIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties;
  variant?: 'light' | 'dark';
}

export default function CSVIcon({ style, variant, ...props }: CSVIconProps) {
  const imgSrc = useMemo(() => {
    if (variant === 'light') {
      return CSVLight;
    }
    return CsvIconComponent;
  }, [variant]);

  return <img {...props} alt="csv icon" src={imgSrc} style={{ ...style }} />;
}
